<template>
  <list-view class="component-type-selector">
    <div class="component-type-button"
      v-for="type in componentTypes"
      v-if="isComponentTypeVisible(type.id)"
      v-bind:disabled="!isComponentTypeEnabled(type.id)"
      v-bind:selected="isComponentTypeSelected(type.id)"
      v-on:click="componentTypeSelected(type.id)">
      <i v-bind:class="iconClass(type.id)"></i>
      <div class="text">{{ type.title }}</div>
    </div>
  </list-view>
</template>

<script>
import listView from 'components/list-view';
import l10n from 'services/l10n-service';
import Product from 'modules/product';

export default {
  name: 'component-type-selector',
  props: [
    'productType',
    'componentTypeDict',
    'targetComponentType',
    'availableComponentTypes'
  ],
  data() {
    return {};
  },
  components: {
    listView
  },
  computed: {
    componentTypes() {
      if (!this.componentTypeDict) {
        return [];
      }

      // combination is a virtual component type
      const componentTypes = [{
        title: l10n.get('combination'),
        id: 'combination'
      }].concat(Object.keys(this.componentTypeDict).map((type) => {
        return this.componentTypeDict[type];
      }));
      return componentTypes;
    }
  },
  methods: {
    isComponentTypeSelected(type) {
      return type === this.targetComponentType;
    },
    isComponentTypeVisible(type) {
      return type !== 'center_chair_leg';
    },
    isComponentTypeEnabled(type) {
      return type === 'combination' || this.availableComponentTypes[type];
    },
    componentTypeSelected(componentType) {
      this.$emit('component-type-selected', componentType);
    },
    iconClass(type) {
      if (this.productType === Product.Type.Table) {
        return `icon-table-${type.replace(/_/, '-')}-select`;
      } else {
        return `icon-${type.replace(/_/, '-')}-select`;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.component-type-selector {
  text-align: left;
  padding-left: 3px;
  padding-right: 3px;
  left: -3px;
  right: -3px;
  overflow: hidden !important;
}

.component-type-selector .component-type-button {
  width: 75px;
  height: 98px;
  text-align: center;
  padding: 8px 10px 10px 10px;
  margin-top: 2px; /* 2px margin for the shadow */
  box-sizing: border-box;
  vertical-align: middle;
  cursor: pointer;
  white-space: normal;
}

.component-type-selector .component-type-button[selected]:hover,
.component-type-selector .component-type-button[selected] {
  background: white;
  box-shadow: 1px 1px 10px silver;
  -moz-box-shadow: 1px 1px 10px silver;
  -webkit-box-shadow: 1px 1px 10px silver;
  position: relative;
  z-index: 1;
}

.component-type-selector .component-type-button:hover {
  background: #E9E9E9;
}

.component-type-selector .component-type-button[disabled] {
  opacity: 0.5;
  pointer-events: none;
}

.component-type-selector i {
  position: relative;
  color: #B2B5AF;
  font-size: 65px;
}
.component-type-selector i:after {
  color: #AED3D3;
}
.component-type-selector i.icon-table-combination-select:before,
.component-type-selector i.icon-table-combination-select:after,
.component-type-selector i.icon-table-chair-leg-select:before,
.component-type-selector i.icon-combination-select:before,
.component-type-selector i.icon-combination-select:after {
  color: #AED3D3; 
}
.component-type-selector i.icon-table-chair-leg-select:after {
  color: #B2B5AF;
}

.component-type-selector .text {
  font-size: 12px;
  margin: 2px -10px 0px -10px;
}

</style>



// WEBPACK FOOTER //
// component-type-selector.vue?409e3656